/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { FaireErrorBoundaryErrorContent } from "@faire/web--source/ui/FaireErrorBoundary/FaireErrorBoundary";
import React from "react";
import { useLogFatalError } from "@faire/retailer-visitor-shared/app/_lib/useLogFatalError";
var Error = function(param) {
    var error = param.error;
    useLogFatalError(error);
    return /*#__PURE__*/ _jsx(FaireErrorBoundaryErrorContent, {
        fullPage: true,
        error: error
    });
};
export default Error;
